import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import { Typography } from '@material-ui/core'

import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'

// views
import ApplicationTable from 'views/Applications/ApplicationTable'
import SigningFlow from '../Components/SigningFlow'

// general api service
import { giveMeAJoke, retrieveDataUsingGraphQL } from '../../services/generalServiceAPI'
import { isEmpty } from 'lodash'
import {  logger } from '../utility/utility'
import appContext from '../../services/context'

const styles = {
  card: {
    maxWidth: 345,
    height: 'max-content',
    overflow: 'visible',
    marginTop: 50,
    // position: 'relative'
  },
  media: {
    height: 140,
  },
  dropdown: {
    // position: 'absolute'
  },
}

const getApplicationInProgress = `
query Application($userId: ID!) {
  applications(userId: $userId, scope: "needToSign", status: "submitted", pageSize:1000) {
    pages
    applications {
      id
      description
      signers {
        id
        level
        position
        fullName
        chineseName
        email
        action
        signedOn
      }
      
      expenseType{
        name
      }
      expenseOrProcurement
      payTo
      amount
      currency
      startDate
      endDate
      type {
        id
        name
        description
        short
      }
      creator {
        id
        name
        email
        company{
          id
          name
          country
        }
      }
      createdOn
      activeStep
      lastLevelToSign
      lastModifiedOn
      status
      archived {
        user {
          firstname
          lastname
        }
        on
      }
      total
    }
  }
}
`

class Dashboard extends React.Component {
  static contextType = appContext
  constructor(props) {
    super(props)
    this.state = {
      joke: 'My dog used to chase people on a bike a lot. It got so bad I had to take his bike away.',
      applications: [],
    }
    this.fetchApplications = this.fetchApplications.bind(this)
  }

  componentDidMount() {
    logger('Dashboard - DidMount:', this.context)
    try {
      giveMeAJoke().then((joke) => {
        if (!isEmpty(joke)) this.setState({ joke: joke.joke })
      })
      this.fetchApplications()
    } catch (e) {
      // console.log(jsonPP(e))
    }
  }
  fetchApplications = () => {
    retrieveDataUsingGraphQL(getApplicationInProgress, { userId: this.context.user.id })
      .then((response) => {
        if (response.ok) {
          // console.log(response)
          return response.json()
        } else {
          logger('[Dashboard][componentDidMount][1]:', { response }, true)
          // throw new Error('Something wrong ' + JSON.stringify(variables))
        }
      })
      .then(({ data }) => {
        // console.log({ data })
        const { applications } = data
        logger('[Dashboard][componentDidMount][2]:', { data }, true)
        this.setState({ applications: applications.applications })
      })
      .catch((error) => logger('[Dashboard][componentDidMount][3]:', error, true))
  }

  render() {
    const { classes, history } = this.props
    const { applications } = this.state
    const { dashboardTheme } = this.context.user
    const themes = {
      TITLING: '2',
      TABULAR: '1',
    }
    logger('[Dashboard][render]:', applications)
    return (
      <Fragment>
        {dashboardTheme === themes.TITLING ? (
          applications.length === 0 ? (
            <Card className={classes.card}>
              {/* <CardActionArea> */}
              <CardMedia className={classes.media} image={require('assets/img/coffee.jpg')} title='Enjoying...' />
              <CardContent>
                <Typography gutterBottom variant='h5' component='h2'>
                  Enjoy your day
                </Typography>
                <Typography component='p'>{this.state.joke}</Typography>
                {/* <FormControl fullWidth>
                  <Datetime calssName={classes.dropdownd} inputProps={{ placeholder: 'Datetime Picker Here' }} />
                </FormControl> */}
              </CardContent>
              {/* </CardActionArea> */}
            </Card>
          ) : (
            <Paper style={{ margin: '10px 0px' }}>
              <GridContainer>
                {applications.map((app, key) => (
                  <GridItem key={`griditem${key}`} xs={12} sm={6} md={4}>
                    <SigningFlow key={`signingflow${key}`} application={app} loginUserId={this.context.user.id} refresh={this.fetchApplications} />
                  </GridItem>
                ))}
              </GridContainer>
            </Paper>
          )
        ) : (
          // <ApplicationTable applications={applications} history={history} />
          <ApplicationTable scope= "needToSign"  status= "submitted" history={history} />
        )}
      </Fragment>
    )
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(Dashboard)
